import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BookButton.css';

interface IProps {
  title: string;
  offerUrl: string;
  handleClick?: () => void;
}

export const BookButton = (props: IProps) => {
  const { title, offerUrl, handleClick } = props;

  return (
    <div className={styles['button-phone-container']}>
      <LinkButton fullWidth href={offerUrl} onClick={handleClick} target="_blank" rel="noopener noreferrer">
        {title}
      </LinkButton>
    </div>
  );
};
